import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Video, Monitor, BarChart3, Settings, Shield, Zap, } from 'lucide-react';
import { useHealth } from '@/hooks/queries';
const NAV = [
    { to: '/', label: 'Dashboard', icon: LayoutDashboard, section: 'Main' },
    { to: '/sources', label: 'Sources', icon: Video, section: 'Main' },
    { to: '/live', label: 'Live', icon: Monitor, section: 'Main' },
    { to: '/redaction', label: 'Redaction', icon: Shield, section: 'Main' },
    { to: '/analysis', label: 'Analysis', icon: BarChart3, section: 'Analysis' },
    { to: '/warehouse', label: 'Warehouse', icon: Zap, section: 'Analysis' },
    // Q&A Chat removed from sidebar — the per-source "Ask" sub-tab in
    // Analysis covers the same backend (`/chat/stream`) with the video and
    // report already in context.
    { to: '/settings', label: 'Settings', icon: Settings, section: 'System' },
];
export function Sidebar() {
    const health = useHealth();
    let dotClass = 'status-dot';
    let label = 'Connecting…';
    let tooltip = 'Polling /health on the EYVA API…';
    if (health.isError) {
        dotClass = 'status-dot error';
        label = 'API unreachable';
        tooltip = 'GET /health failed — check API pod / port-forward.';
    }
    else if (health.data) {
        dotClass = 'status-dot';
        label = `API ${health.data.status ?? 'ok'}`;
        const llm = health.data.model ?? '—';
        const vlm = health.data.vlm_model ?? '—';
        tooltip = `EYVA API healthy\nLLM: ${llm}\nVLM: ${vlm}`;
    }
    const sections = ['Main', 'Analysis', 'System'];
    return (_jsxs("aside", { className: "sidebar", children: [_jsxs("div", { className: "sidebar-header", children: [_jsxs("svg", { viewBox: "0 0 40 40", width: 40, height: 40, style: { flexShrink: 0 }, children: [_jsx("rect", { width: "40", height: "40", fill: "#FFE600", rx: "3" }), _jsx("text", { x: "20", y: "28", textAnchor: "middle", fill: "#2E2E38", fontFamily: "Arial,sans-serif", fontWeight: "900", fontSize: "19", children: "EY" })] }), _jsxs("div", { className: "brand-block", children: [_jsx("span", { className: "brand-eyva", children: "EY Video Analyzer" }), _jsx("span", { className: "brand-sub", children: "Video Analysis Platform" })] })] }), _jsx("nav", { className: "sidebar-nav", children: sections.map((section) => (_jsx("span", { className: "nav-section-label", children: section }, section))).flatMap((heading, idx) => {
                    const section = sections[idx];
                    const items = NAV.filter((n) => n.section === section).map((n) => {
                        const Icon = n.icon;
                        return (_jsxs(NavLink, { to: n.to, end: n.to === '/', className: ({ isActive }) => `nav-item${isActive ? ' active' : ''}`, children: [_jsx(Icon, { size: 17, strokeWidth: 2 }), _jsx("span", { children: n.label })] }, n.to));
                    });
                    return [heading, ...items];
                }) }), _jsxs("div", { className: "sidebar-footer", children: [_jsxs("div", { className: "api-status-bar", title: tooltip, children: [_jsx("span", { className: dotClass }), _jsx("span", { className: "status-text", children: label })] }), _jsx("div", { className: "version-label", children: "EY Video Analyzer" })] })] }));
}
